import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { AgentItemApi } from "@/Modules/Agent/Models/Api";
import type { AgentItem } from "@/Modules/Agent/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const AnswerTransformer: TransformerExtended<AgentItem, AgentItemApi> = {
  ...DefaultTransformerGenerator<AgentItem, AgentItemApi>(),

  toDomain(input: AgentItemApi) {
    return camel<AgentItemApi, AgentItem>(input);
  },
};

export type AnswerTransformerType = TransformerExtended<AgentItem, AgentItemApi>;

export default AnswerTransformer;
